import React from 'react';
import { CircleAlert } from 'lucide-react';

function ErrorPage() {
  return (
    <main className="adm_error_page" aria-labelledby="error-page-title">
      <div className="error_page_panel">
        <CircleAlert className="error_page_icon" size={70} strokeWidth={2} aria-hidden="true" focusable="false" />
        <p className="error_page_status">404</p>
        <div className="error_page_message">
          <h1 id="error-page-title" className="error_page_title">요청하신 페이지를 찾을 수 없습니다.</h1>
          <p className="error_page_description">
            <span>찾으시는 페이지가 존재하지 않거나 잘못된 주소를 입력하셨습니다.</span>
            <span>계속해서 서비스를 이용하시려면 홈으로 이동해 주세요.</span>
          </p>
        </div>
        <a className="adm_com_btn m blue oval bold error_page_home" href="/">홈으로 이동</a>
      </div>
      <hr className="error_page_divider" aria-hidden="true" />
    </main>
  );
}

export default ErrorPage;
